import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function startCheckout() {
  const origin = window.location.origin;
  const { data } = await axios.post(`${API}/paypal/create-order`, { origin });

  if (data.demo) {
    // No real PayPal keys yet — simulate the purchase flow.
    window.location.href = `/thank-you?demo=1&order=${data.order_id}`;
    return;
  }
  // Redirect to PayPal hosted approval page.
  window.location.href = data.approve_url;
}
